<template lang="pug">
.col-12.pt-5.mt-4.d-flex.justify-content-center
    .white-arrow.pt-4.text-center.col-1.d-none.d-sm-block
        a(:href='urlRef')
            i.arrow
</template>

<script>
export default {
    props: {
        urlRef: { type: String, required: true }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Arrow.vue